// React:
import React from "react";
// MUI Components:
import { Grid, Typography, useTheme } from "@mui/material";
// Components:
import ReportsTable from "./reports-table/ReportsTable";
import ReportsSearch from "./reports-search/ReportsSearch";

const Reports = () => {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "24px",
            color: theme.palette.text.secondary,
            mb: "8px",
            [theme.breakpoints.down("md")]: {
              fontSize: "20px",
              mb: "6px",
            },
          }}
        >
          Reports
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <ReportsSearch />
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          height: "calc(100% - 119px)",
          [theme.breakpoints.down("md")]: {
            height: "calc(100% - 102px)",
          },
        }}
      >
        <ReportsTable />
      </Grid>
    </>
  );
};

export default Reports;
